import { RateSource } from "@redotech/money/rate-source";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTablePaddedCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { MoneyText } from "@redotech/redo-web/fx/money-text";
import { SkeletonText } from "@redotech/redo-web/skeleton";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";

const catalogEntry = fgColumnEntries.rate;

export const RateColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => {
    if (row.ratesPendingSince) {
      return (
        <RedoTablePaddedCell>
          <SkeletonText length={8} />
        </RedoTablePaddedCell>
      );
    }
    // rateMoney (carrier currency, USD default) → MoneyText converts to shop
    // currency. Stripe source so the preview matches the settlement rate charged.
    return (
      <RedoTablePaddedCell>
        <Text as="span" fontSize="xs" fontWeight="regular" textColor="tertiary">
          <MoneyText
            source={RateSource.Stripe}
            value={row.fulfillmentInfo?.rateMoney}
          />
        </Text>
      </RedoTablePaddedCell>
    );
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
